import { generators } from './generators';
import { PullRequestsRequest } from './pullRequests/generators';
import { selectors } from './selectors';
import URI from 'urijs';
import { BulkToggleCommentPostingRequest } from './commentPosting/commentPosting';
import { call, select } from 'redux-saga/effects';
import { fetchProjects } from 'sagas/projects';
import { organizationSelector } from 'selectors/Organization';
import { Organization } from 'models/Organization';
import { UpdateOrganizationAvatarRequest } from './settings/settings';
import { getAccount } from 'sagas/Account';

export function pullRequestsPagesInitialURL({
  organizationUUID,
  author,
  status,
  title,
  repositoryUUID,
  hasReviews,
  pageNumber,
}: PullRequestsRequest) {
  const uri = new URI(
    `/api/v1/organizations/${organizationUUID}/pull-requests/${status}`
  );
  if (author) {
    uri.addQuery('author', author);
  }
  if (title) {
    uri.addQuery('title', title);
  }
  if (repositoryUUID) {
    uri.addQuery('repository_uuid', repositoryUUID);
  }
  if (hasReviews !== undefined) {
    uri.addQuery('has_reviews', Number(hasReviews));
  }
  if (pageNumber) {
    uri.addQuery('page', pageNumber);
  }

  return uri.toString();
}

function* refreshOrganizationProjects() {
  const organization: Organization | undefined = yield select(
    organizationSelector
  );
  if (organization) {
    yield fetchProjects({
      providerId: organization?.providerId,
      organizationSlug: organization?.slug,
    });
  }
}

function* refreshAccount() {
  yield getAccount();
}

export function* sagas() {
  yield generators.pullRequests.pages.saga(
    pullRequestsPagesInitialURL,
    selectors.pullRequests.pages
  );
  yield generators.commentPosting.toggle.saga(
    (api, request: BulkToggleCommentPostingRequest) =>
      call(
        api.put,
        `/api/v1/organizations/${request.organizationUUID}/projects/comment-posting`,
        {
          enabled: request.isEnabled,
        }
      ),
    refreshOrganizationProjects
  );
  yield generators.settings.updateAvatar.saga(
    (api, request: UpdateOrganizationAvatarRequest) =>
      call(
        api.upload,
        `/api/v1/organizations/${request.organizationUuid}/avatar`,
        'photo',
        request.image
      ),
    // refresh account since avatars are pulled from the account organizations response data
    refreshAccount
  );
}
